import React, { useState, useRef, useEffect } from "react";
import { Empty, Button, Checkbox, Select, Input,Space,DatePicker } from "antd";

import "./TableSelectable.scss";
import dayjs from "dayjs";


export default function   HolidaysConfigTable({
  isClickable = false,
  titleList,
  data,
  isEditField = true,
  config,
  modifyTable,
  handleCallBack
}) {

  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]); 
  const [currentData, setCurrentData] = useState([...data]); 
  const [newHolidayAdded, setNewHolidayAdded] = useState(false);
  const [holidayRemoved, setHolidayRemoved] = useState(false);

  useEffect(() => {
    const checkBoxArray = data?.map((item,idx) => {
      return {
        select:"",
        id:idx,
        location: item.location,
        holidayname: item.holidayname,
        date: item.date,
        isSelected: false,
      };
    });
    setCheckBoxData([...checkBoxArray]);
    setCurrentData([...data])
  }, [data]);

  if (!data) {
    return <Empty style={{ margin: "60px" }} />;
  }

  function enableDbUpdate() {
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      if (checkBoxData[idx].isSelected) {
        return true;
      }
    }
    return false;
  }
  const onCheckBoxChange = (e) => {
    if (e.target.checked) {
      checkBoxData[e.target.value].isSelected = true;
    } else {
      checkBoxData[e.target.value].isSelected = false;
    }
    if (enableDbUpdate() == true) {
      setUpdateAvailable(true);
    } else {
      setUpdateAvailable(false);
    }
    setCheckBoxData(() => [...checkBoxData]);
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const getUpdated = (rowIndex) => {
    return checkBoxData[rowIndex]?.isSelected;
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedValues = [...checkBoxData];
    updatedValues[index] = { ...updatedValues[index], [name]: value };
    setCheckBoxData(updatedValues);
  };


   const encodeJson = (updateType) =>{

        let encodedJsonValues ={};
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        //now fill the parameters
        encodedJsonValues.holidayarray =[];
        
        var num=0
        for(let idx = 0; idx < checkBoxData.length; idx++){
           //console.log("checkBoxData", idx,checkBoxData[idx])
           if (checkBoxData[idx].isSelected && updateType =="UPDATE" ) {
                encodedJsonValues.action = "UPDATE"
                encodedJsonValues.holidayarray[num]={};
                encodedJsonValues.holidayarray[num].holidayid =idx;
                encodedJsonValues.holidayarray[num].date =checkBoxData[idx].date;
                encodedJsonValues.holidayarray[num].location =checkBoxData[idx].location;
                encodedJsonValues.holidayarray[num].holidayname =checkBoxData[idx].holidayname;
                num++;                  
            } else if (checkBoxData[idx].isSelected && updateType =="DELETE" ) {
                encodedJsonValues.action = "DELETE"
                encodedJsonValues.holidayarray[num]={};
                encodedJsonValues.holidayarray[num].holidayid =idx;
                encodedJsonValues.holidayarray[num].holidayname =checkBoxData[idx].holidayname; 
                num++;               
            }                       
        } 
        if (updateType =="ADD" ) {
            var idx = checkBoxData.length -1 
            num =0
            encodedJsonValues.action = "ADD"
            encodedJsonValues.holidayarray[num]={};
            encodedJsonValues.holidayarray[num].holidayid =idx;
            encodedJsonValues.holidayarray[num].location =checkBoxData[idx].location;
            encodedJsonValues.holidayarray[num].date =checkBoxData[idx].date;
            encodedJsonValues.holidayarray[num].holidayname =checkBoxData[idx].holidayname;            
        }               
        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatetype = updateType
        encodedJsonValues.updatedby= userData.qhuid;
        encodedJsonValues.updatedbyname= userData.username;
        encodedJsonValues.updatedon    = newDate;
             
        return encodedJsonValues
    }

const handleHolidayCancel = (value) => {
    for(let idx = 0; idx < checkBoxData.length; idx++){
      checkBoxData[idx].isSelected = false;
    }    
    setCheckBoxData(() => [...checkBoxData]);    
    setUpdateAvailable(false);
}

const getSortedHolidays = (itemArr) => {
  const sortedHolidays = [...itemArr].sort((a, b) => {
    const [d1, m1, y1] = a.date.split("-").map(Number);
    const [d2, m2, y2] = b.date.split("-").map(Number);

    const dateA = new Date(y1, m1 - 1, d1);
    const dateB = new Date(y2, m2 - 1, d2);

    return dateA - dateB;
  });  

  console.log("Sorted Holidays",sortedHolidays)
  return sortedHolidays;
}

const handleHolidaySave = (value) => {
  
    //first sort the holidays based on date
    //var sortedHolidays = getSortedHolidays(checkBoxData)
    var jasonValues= encodeJson("UPDATE")
    console.log("Encode json",jasonValues)
    handleCallBack(jasonValues,"UPDATE")
    for(let idx = 0; idx < checkBoxData.length; idx++){
      checkBoxData[idx].isSelected = false;
    }    
    setCheckBoxData(() => [...checkBoxData]);    
    setUpdateAvailable(false);
}

const handleRemove = (value) => {
    //please remember ...did only to rerender the table. If we do
    setHolidayRemoved(true)     
    setUpdateAvailable(false);
}
  const handleAddItem = () => {
    const newItemC = 
               {
	                select: "",
                  id: checkBoxData.length+1,
                  holidayname:"Please Add",
                  location:"All",
                  date: "mm-dd-yyyy",
              }
    const newItem = 
               {
	                select: "",
                  id: checkBoxData.length,
                  holidayname:"Please Add",
                  location:"All",
                  date: "mm-dd-yyyy",
                  isSelected: false,
              } 
    console.log("adding new item",newItemC)                           
    setCurrentData([...currentData, newItemC])
    setCheckBoxData([...checkBoxData, newItem]);

    //please remember ...did only to rerender the table. If we do
    setNewHolidayAdded(true)   
    
  };

  function handleNewHolidayAdded () {
    var jasonValues= encodeJson("ADD")
    handleCallBack(jasonValues,"ADD")
    for(let idx = 0; idx < checkBoxData.length; idx++){
      checkBoxData[idx].isSelected = false;
    }   
    setNewHolidayAdded(false)       
  };

  function handleHolidayRemoved () {
    var jasonValues= encodeJson("DELETE")
    handleCallBack(jasonValues,"DELETE")
    var tmp = checkBoxData
    var tmpData = currentData
    for(let idx = 0; idx < checkBoxData.length; idx++){
      if(checkBoxData[idx].isSelected == true){
         tmp = tmp.filter((item)=> item.id != idx)
         tmpData = tmpData.filter((item)=> item.id-1 != idx)
      }
      checkBoxData[idx].isSelected = false;
    }   
    //reset the ids
    for(let idx = 0; idx < tmp.length; idx++){
      tmp[idx].id = idx
      tmpData[idx.id] = idx+1
    }

    setCheckBoxData([...tmp]);   
    setCurrentData([...tmpData]);     
    setHolidayRemoved(false)       
  };  

  function convertToDDMMYYYY(dateStr) {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
    }  

  function getValidValue (rowIndex) {
     if (checkBoxData[rowIndex]?.date != ""){
       return  checkBoxData[rowIndex]?.date
     }else {
        return getTimeNow() 
     }   
  }
  const handleDate  = (date,dateString,rowIndex) =>{
    console.log("Selected Date rowindex", dateString, rowIndex)
    const updatedValues = [...checkBoxData];
    updatedValues[rowIndex] = { ...updatedValues[rowIndex], ["date"]: convertToDDMMYYYY(dateString) };

    console.log("Update Data", updatedValues)
    setCheckBoxData([...updatedValues]);        

  }
  return (
    <div className="evaluation-Setting-table-wrapper">
      <div className="rtable-selectable-btn-wrapper">  
        {
          modifyTable?
          <>
            <Button
              className="rtable-selectable-btn"
              onClick={handleAddItem}
            >
              Add New Holiday
            </Button>             
          </>
          :<>
          </>
        }      

      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: config,
        }}
      >
        {titleList.map((title) =>
            <div className="rtable-title">{title}</div>
        )}
      </div>
      {currentData?.map((table, rowIndex) => (
        <div
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: config,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div className="rtable-info">
              {isEditField ? (
                <div className="edit-field-wrapper">
                  <>
                    {tableInfo === "id" ? rowIndex + 1 : <></>}

                    {tableInfo === "select" ? (
                      <Checkbox
                        value={rowIndex}
                        onChange={onCheckBoxChange}
                        checked={getUpdated(rowIndex)}
                      ></Checkbox>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "holidayname" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="holidayname"
                            value={checkBoxData[rowIndex]?.holidayname}
                            placeholder={checkBoxData[rowIndex]?.holidayname}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}  
                    {tableInfo === "location" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="location"
                            value={checkBoxData[rowIndex]?.location}
                            placeholder={checkBoxData[rowIndex]?.location}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}                     
                    {tableInfo === "date" ? (
                      <>
                        {getUpdated(rowIndex) === true ? <>
                                <Space direction="vertical">
                                    <DatePicker 
                                      name = "date"
                                      onChange={(date,dateString)=>handleDate(date,dateString,rowIndex)}
                                      placeholder={checkBoxData[rowIndex]?.date !=""?
                                                      checkBoxData[rowIndex]?.date:dayjs().format("DD-MM-YYYY")}
                                    />
                                </Space>                                 
                        </> : <>{table[tableInfo]}</>}
                      </>
                    ) : (
                      <></>
                    )}                                                           
                  </>
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
      <div className="rtable-selectable-btn-wrapper" style={{ marginTop: "10px" }}>
        {
          modifyTable?
          <>
            <Button
              className="rtable-selectable-btn"
              disabled={!updateAvailable}
              onClick={handleHolidaySave}
            >
              Save Changes
            </Button>          
            <Button
              className="rtable-selectable-btn"
              disabled={!updateAvailable}
              onClick={handleRemove}
            >
              Remove Holiday
            </Button>  
            <Button
              className="rtable-selectable-btn"
              disabled={!updateAvailable}
              onClick={handleHolidayCancel}
            >
              Cancel Selection
            </Button>                     
          </>
          :<></>
        }  
              
      </div>   
      {newHolidayAdded? handleNewHolidayAdded():<></>}   
      {holidayRemoved? handleHolidayRemoved():<></>}  
    </div>
  );
}
